import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import DisbursementList from '../../../components/List/Disbursement/DisbursementList'
import { DisbursementOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'
import useEntity from '../../../hooks/useEntity'
import { Spinner, SpinnerSize } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

export default function DisbursementOverview(props: RegistrationListProps<DisbursementOverviewDto>): ReactElement {
    const { t: translate } = useTranslation()

    const [lazyItems, , resetLazyItems] = useEntity<DisbursementOverviewDto[]>(
        () => ({ url: `/file/${props.listProps.file.id}/disbursement` }),
        props.items === null ? false : null,
    )
    const isItemsLoaded = useMemo(() => props.items !== null || lazyItems.loaded, [props.items, lazyItems])

    const lazyProps: RegistrationListProps<DisbursementOverviewDto> = useMemo(
        () => ({ ...props, items: lazyItems?.data, reset: resetLazyItems }),
        [isItemsLoaded],
    )

    if (!isItemsLoaded) {
        return <Spinner label={translate('base.loading')} size={SpinnerSize.small} labelPosition="right" />
    }
    if (props.items === null) {
        return <DisbursementList {...lazyProps} />
    }

    return <DisbursementList {...props} />
}
